const ValuePerUnit = ({ price, prevPrice, isPromo, renderPrice = true }) => {
  if (!renderPrice) {
    return (
      <div className="product__price">
        <strong>&nbsp;</strong>
      </div>
    );
  }

  return (
    <div
      className={`product__price ${
        prevPrice !== null || isPromo ? 'with-prev-price' : ''
      }`}
    >
      <strong>{price} &#x20BD;</strong>
      {prevPrice !== null && <small>{prevPrice} &#x20BD;</small>}
    </div>
  );
};

export default ValuePerUnit;
